<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{ $t('Email') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="home-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="home-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>
      <div class="row">
        <div class="col-md-3">
          <input-widget type="checkbox" :model="model" attribute="enable_email" is-switch/>
        </div>
        <div class="col-md-3" v-if="!hideBccLoggedInAndFrom">
          <input-widget type="checkbox" :model="model" attribute="change_from_to_logged_in" is-switch/>
        </div>
        <div v-if="model.template_type && model.template_type.includes_attachment" class="col-md-3">
          <input-widget type="checkbox" :model="model" attribute="include_attachment" is-switch/>
        </div>
      </div>
      <div class="row">
        <div v-if="model.template_type && !hideBccLoggedInAndFrom" class="col-md-6">
          <input-widget :model="model" attribute="from_address" :append-question="fromAddressHint"/>
        </div>
        <div v-if="model.template_type && model.template_type.requires_to_attribute" class="col-md-6">
          <input-widget :rules="model.enable_email ? 'required' : ''" :model="model" attribute="to" type="tags"/>
        </div>
        <div v-if="model.template_type && model.template_type.requires_bcc_attribute && !hideBccLoggedInAndFrom" class="col-md-6">
          <input-widget :model="model" attribute="bcc" type="tags"/>
        </div>
        <div class="col-md-12">
          <translatable-input-widget :hint="false" :model="model" :fields="model.getEmailFields()" :rules="rules"
                                     :errors="errors" @onCkeditorReady="$emit('onCkeditorReady')"/>
        </div>
      </div>
      <template-variables v-if="model.template_type" :variables="model.template_type.variables"/>
    </b-tab>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import TemplateVariables from "@/modules/setup/templates/TemplateVariables";
  import TranslatableInputWidget from "@/core/widgets/TranslatableInputWidget";

  export default {
    name: "EmailForm",
    components: {TranslatableInputWidget, TemplateVariables, InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        fromAddressHint: this.$i18n.t('Following field is utilized to modify the "From" address visible to the email recipient. Please make sure that the email address entered is supported by the SMTP provider currently in use. Should you require further clarification or assistance, contact us at helpdesk@artisio.co.')
      };
    },
    computed: {
      rules() {
        return {
          body: this.model.enable_email ? 'required' : null,
          subject: this.model.enable_email ? 'required' : null,
        }
      },
      hideBccLoggedInAndFrom() {
        return this.model && this.model.template_type && [
          'webapp_email_confirmation',
          'webapp_password_reset',
          'lot_notify_start_notification',
          'lot_start_subscribe_notification',
          'lot_inquiry_notification',
          'bid_deleted_notification',
        ].includes(this.model.template_type.key)
      }
    },
    methods: {
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      }
    },
    watch: {
      'model.from_address': {
        handler(addresses) {
          if (Array.isArray(addresses) && addresses.length > 1) {
            this.model.from_address = addresses.slice(0, 1);
          }
        },
        deep: true,
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
